<template>
  <div>
    <list
      row-key="DeviceId"
      ref="list"
      unit="考勤设备"
      :page="false"
      :show-checkbox="true"
      :showToolbar="$permission.canWrite()"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column label="班级" min-width="120px">
          <template slot-scope="{row}">
            <span>高{{getGrade(row.GradeSn)}}（{{row.ClassSn}}）班</span>
          </template>
        </el-table-column>
        <el-table-column label="IP" prop="Ip" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  data() {
    return {
      api: require("@/api/at/device").default,
    };
  },
  methods: {
    getGrade(GradeSn) {
      var grade_sn = "一";
      switch (GradeSn) {
        case 1:
          grade_sn = "一";
          break;
        case 2:
          grade_sn = "二";
          break;
        case 3:
          grade_sn = "三";
          break;
      }
      return grade_sn;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    export() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData({});
      });
    },
  },
};
</script>